import React from 'react'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { imgUrl } from '../../../api/api';
import { ReactComponent as JpgIcon } from "../../../Assets/images/jpgIcon.svg";
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';

const fmt = d => d ? new Date(d).toLocaleDateString('ko-KR', { year:'numeric', month:'2-digit', day:'2-digit' }) : '-';

function Vedio({ data, checked, onCheck, usedIn, deleteSingleContent, onPreview }) {
  return (
    <div className="content-list-item" style={{ background: checked ? 'rgba(85,31,255,0.05)' : 'white' }}>
      <div className="content-list-checkbox">
        <input type="checkbox" checked={!!checked} onChange={() => onCheck(data.id)} style={{ cursor: 'pointer' }} />
      </div>
      <div className="content-list-thumbnail content-list-thumbnail--video" onClick={() => onPreview && onPreview(data)} style={{ cursor: 'pointer' }}>
        <video src={`${imgUrl}/${data.url}`} />
        <div className="content-list-video-overlay">
          <OndemandVideoIcon style={{ color: 'white', fontSize: 24 }} />
        </div>
      </div>
      <div className="content-list-info" onClick={() => onPreview && onPreview(data)} style={{ cursor: 'pointer' }}>
        <p className="content-list-name" title={data.name}>{data.name}</p>
        <span className="content-list-type">
          <JpgIcon style={{ width: 14, height: 14 }} />
          {data.type}
        </span>
      </div>
      <div className="content-list-usage" title={(usedIn || []).join(', ')}>
        {(usedIn || []).length > 0 ? `${usedIn.length}개 플레이리스트` : <span style={{ color: '#ccc' }}>미사용</span>}
      </div>
      <div className="content-list-date">{fmt(data.createdAt)}</div>
      <div className="content-list-actions">
        <button onClick={() => deleteSingleContent(data.id)} style={{ background: 'none', border: 'none', padding: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', touchAction: 'manipulation' }}>
          <DeleteOutlineIcon style={{ color: '#551FFF', fontSize: 22 }} />
        </button>
      </div>
    </div>
  )
}

export default Vedio
